import { AxiosError } from 'axios';
import { useQuery, UseQueryResult, UseQueryOptions } from '@tanstack/react-query';
import { couponQueryKeys } from '../../../constants/queryKeys/coupon';
import { CouponApiV2 } from '../../../lib/api/coupon/CouponApiV2';

type CouponDetailResponse = Awaited<ReturnType<typeof CouponApiV2.getCouponDetail>>;

type CouponDetailData = {
  couponInfo: Record<string, unknown>;
  couponStatistics: Record<string, unknown>;
  couponUsageHistory: { couponUsageHistoryList: Record<string, unknown>[]; totalCnt: number };
  couponUnUsageHistory: { couponUnUsageHistoryList: Record<string, unknown>[]; totalCnt: number };
  couponProductLink?: { couponProductLinkList: Record<string, unknown>[]; totalCnt: number };
  couponBrandLink?: { couponBrandLinkList: Record<string, unknown>[]; totalCnt: number };
  mainProductCategorySelectList?: Record<string, unknown>[];
  subProductCategorySelectList?: Record<string, unknown>;
};

export const useCouponDetailQuery = (
  couponId: number,
  initialPayload: Record<string, unknown>,
  options?: UseQueryOptions<CouponDetailResponse, AxiosError, CouponDetailData>,
): UseQueryResult<CouponDetailData, AxiosError> => {
  return useQuery(
    couponQueryKeys.couponDetail(couponId),
    () => CouponApiV2.getCouponDetail({ couponId, ...initialPayload }),
    {
      select: (res: CouponDetailResponse) => {
        const data = res.data as CouponDetailData;
        // 레거시 reducer와 동일하게 couponStatistics.chartData 매핑
        if (data.couponStatistics) {
          data.couponStatistics = {
            ...data.couponStatistics,
            chartData: [
              { key: 'used', name: '쿠폰 사용', value: data.couponStatistics.used ?? 0 },
              { key: 'unUsed', name: '쿠폰 미사용', value: data.couponStatistics.unUsed ?? 0 },
            ],
          };
        }
        return data;
      },
      enabled: !!couponId,
      ...options,
    },
  );
};
